import { memo, useEffect, useRef } from 'react'

import { getEffectiveTheme, useSessionTheme } from '@context/SessionSettingsContext'

import styles from './InsightsTabBody.module.scss'

interface InsightsTabBodyProps {
  symbol: string
}

export const InsightsTabBody = memo(({ symbol }: InsightsTabBodyProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const widgetRef = useRef<HTMLDivElement | null>(null)
  const colorTheme: 'light' | 'dark' = getEffectiveTheme(useSessionTheme())

  useEffect(() => {
    if (!containerRef.current) return

    const wrapper = document.createElement('div')
    wrapper.className = 'tradingview-widget-container'

    const widgetDiv = document.createElement('div')
    widgetDiv.className = 'tradingview-widget-container__widget'
    wrapper.appendChild(widgetDiv)

    const copyright = document.createElement('div')
    copyright.className = 'tradingview-widget-copyright'
    wrapper.appendChild(copyright)

    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-timeline.js'
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = JSON.stringify({
      displayMode: 'regular',
      feedMode: 'symbol',
      symbol: `TICKMILL:${symbol}`,
      colorTheme,
      isTransparent: true,
      locale: 'en',
      width: '100%',
      height: '100%',
    })
    wrapper.appendChild(script)

    containerRef.current.appendChild(wrapper)
    widgetRef.current = wrapper

    return () => {
      if (widgetRef.current && widgetRef.current.parentNode) {
        widgetRef.current.parentNode.removeChild(widgetRef.current)
      }
      widgetRef.current = null
    }
  }, [symbol, colorTheme])

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    />
  )
})

InsightsTabBody.displayName = 'InsightsTabBody'
